export default async function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (): void => {
      if (reader.result) {
        resolve(String(reader.result));
      } else {
        reject(new Error('Failed base64 decode'));
      }
    };
    reader.onerror = reject;
  });
}
